import { get, post, put } from "../Config";

export function DDSegmentation() {
  return get({ url: `/api/g99/v1/dropdown/segmentation`});
}
